import tensureLogo from '../../assets/images/Tensure_logo.jpg';

const LogoIcon = () => {
  return (
    <img src={tensureLogo} alt="Tensure Logo" style={{ height: 5, width: 'auto' }} />
  );
};

export default LogoIcon;
